"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoModal = void 0;
exports.hasVideoModal = hasVideoModal;
var player_1 = __importDefault(require("@vimeo/player"));
var youtube_player_1 = __importDefault(require("youtube-player"));
var config_1 = require("../config");
var video_1 = require("../helper/video");
var VideoModal = /*#__PURE__*/function () {
  function VideoModal() {
    var _this = this;
    _classCallCheck(this, VideoModal);
    this.videoModals = [];
    this.loadPlayer = this.loadPlayer.bind(this);
    var videoModals = document.querySelectorAll(config_1.CONFIG.videoModal.main);
    this.videoModals = Array.from(videoModals).map(function (videoModal) {
      if (document.querySelectorAll(config_1.CONFIG.videoModal.modalClass).length === 0) {
        videoModal.addEventListener('click', function (event) {
          event.preventDefault();
          _this.loadPlayer(videoModal);
        });
      }
    });
  }
  return _createClass(VideoModal, [{
    key: "loadPlayer",
    value: function loadPlayer(element) {
      var _this2 = this;
      var modalElement = document.createElement('div');
      modalElement.className = 'modal active';
      modalElement.innerHTML = '<a class="close-icon" href="/" data-hook="close">\n' + '                         <svg viewBox="0 0 40 40" width="20" height="20">\n' + '                             <use xlink:href="/resources/themes/cffc/images/icons/_icon.svg#x"></use>\n' + '                         </svg>\n' + '                     </a>\n' + '                     <div class="video-player-wrapper">\n' + '                         <div class="video-player"></div>\n' + '                     </div>';
      element.parentNode.insertBefore(modalElement, element.nextSibling);
      var videoLink = element.getAttribute('href');
      var videoDetails = (0, video_1.parseVideo)(videoLink);
      var playerElement = modalElement.querySelector(config_1.CONFIG.videoModal.playerClass);
      var videoPlayer = null;
      if (playerElement) {
        switch (videoDetails.type) {
          case 'youtube':
            videoPlayer = (0, youtube_player_1["default"])(playerElement, {
              playerVars: {
                rel: 0
              }
            }, false);
            videoPlayer.loadVideoById(videoDetails.id);
            break;
          case 'vimeo':
            videoPlayer = new player_1["default"](playerElement, {
              id: Number(videoDetails.id)
            });
            videoPlayer.play();
            break;
          default:
            break;
        }
      }
      var closeButton = modalElement.querySelector(config_1.CONFIG.videoModal.close);
      if (closeButton) {
        closeButton.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.closePlayer(modalElement, videoPlayer);
        });
      }
      modalElement.addEventListener('click', function (event) {
        event.preventDefault();
        _this2.closePlayer(modalElement, videoPlayer);
      });
      modalElement.querySelector('.video-player-wrapper').addEventListener('click', function (event) {
        event.preventDefault();
        _this2.closePlayer(modalElement, videoPlayer);
      });
      document.addEventListener('keydown', function (event) {
        event.preventDefault();
        if (event.key === 'Escape') {
          _this2.closePlayer(modalElement, videoPlayer);
        }
      });
    }
  }, {
    key: "closePlayer",
    value: function closePlayer(modalElement, player) {
      if (player && player.origin && player.origin.includes('vimeo')) {
        player.destroy();
      } else {
        player.stopVideo();
      }
      if (modalElement && modalElement.parentNode) {
        modalElement.parentNode.removeChild(modalElement);
      }
    }
  }]);
}();
exports.VideoModal = VideoModal;
function hasVideoModal() {
  if (document.querySelectorAll(config_1.CONFIG.videoModal.main).length > 0) {
    return true;
  }
  return false;
}